import ApiClient from "~/admin/services/ApiClient";
import queryString from "query-string";

export default class AdminsApi {
  static paginate = (searchName = null, page = null) => {
    let params = {};

    params.searchName = searchName;
    params.page = page;

    return ApiClient.get(`admins/paginate?${queryString.stringify(params)}`);
  };
  static get = (adminId) => ApiClient.get(`admins/${adminId}`);

  static create = (formData) => ApiClient.post("admins", formData);
  static update = (adminId, formData) =>
    ApiClient.patch(`admins/${adminId}`, formData);
}
